
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"180","height":"180","viewBox":"-10 -10 220 220","fill":"none","color":"#A793F6"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a"}},[_c('stop',{attrs:{"offset":"0%","stop-opacity":"0","stop-color":"currentColor"}}),_c('stop',{attrs:{"offset":"100%","stop-opacity":".5","stop-color":"currentColor"}})]),_c('linearGradient',{attrs:{"id":"b"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"currentColor"}}),_c('stop',{attrs:{"offset":"100%","stop-opacity":".5","stop-color":"currentColor"}})])]),_c('g',{attrs:{"stroke-width":"13"}},[_c('path',{attrs:{"stroke":"url(#a)","d":"M4 100a96 96 0 01192 0"}}),_c('path',{attrs:{"stroke":"url(#b)","d":"M196 100a96 96 0 01-192 0"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","d":"M4 100a96 96 0 010-2"}})]),_c('animateTransform',{attrs:{"from":"0 0 0","to":"360 0 0","attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1300ms"}})])
          )
        }
      }
    